var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM17.336 16.2115C17.615 16.4861 17.6194 16.9333 17.3471 17.2145C17.0725 17.4935 16.6253 17.4979 16.3441 17.2256L12 12.9678L7.6559 17.2234C7.37693 17.4979 6.92746 17.4935 6.65291 17.2123C6.37836 16.9333 6.38279 16.4839 6.66398 16.2093L10.9881 11.9759L6.66398 7.74031C6.385 7.46576 6.38057 7.01851 6.65291 6.73732C6.92746 6.45834 7.37471 6.45391 7.6559 6.72625L12 10.984L16.3441 6.72846C16.6231 6.45391 17.0725 6.45834 17.3471 6.73953C17.6216 7.01851 17.6172 7.46798 17.336 7.74253L13.0119 11.9759L17.336 16.2115Z",
    fill: "#353C49",
    fillOpacity: 0.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwError);
export default __webpack_public_path__ + "static/media/pw_error.4bf4de0f788d0125b3e897205f702f17.svg";
export { ForwardRef as ReactComponent };